import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { useStyles } from './styles';
import useInAppGuide from './useInAppGuide';

import usePageTransitions from '../../store/models/animations/usePageTransitions';
import {
    TransitionViewNames,
} from '../../store/models/animations/actions/transitions';
import { useAppStore } from '../../store/models/app';
import useKickstarted from '../../commons/hooks/useKickstarted';
function InAppGuide (props) {
    const {
        viewAnimation = false,
        initStyles = {},
    } = props;

    const classes = useStyles({
        viewAnimation,
        initStyles,
    });

    const appStore = useAppStore();

    const {
        imageURL,
    } = useInAppGuide();

    usePageTransitions({
        elementName: TransitionViewNames.INAPP_GUIDE_VIEW,
        viewAnimation,
    });

     useKickstarted({
        onKickstarted: () => {},
    });

    if (!appStore.kickstarted) {
        return (<React.Fragment></React.Fragment>);
    }
    
    return (
        <React.Fragment>
            <Grid
                id="content"
                name={TransitionViewNames.INAPP_GUIDE_VIEW}
                className={classes.container}
            >
                <Box
                    component="img"
                    sx={{
                        height: '100%',
                        width: '100%',
                    }}
                    alt="In-App-Guide"
                    src={imageURL}
                />
            </Grid>  
        </React.Fragment>
    );
}

InAppGuide.propTypes = {
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};

export default InAppGuide;
